import { IStandardMessage } from '../entities/access-settings.interface';

export const DEFAULT_MESSAGES: Record<string, IStandardMessage> = {
  'pt-BR': {
    Birthday: 'Parabéns pelo seu aniversário!',
    EvaluationExpired: 'Avaliação física vencida',
    PassesExhausted: 'Passes esgotados',
    EntryCustomer: 'Bom treino!',
    EntryCustomerPass: 'Bom treino! Restam [restam] passes',
    EntryEmployee: 'Bom trabalho!',
    MedicalExamExpired: 'Exame médico vencido',
    OutOfHours: 'Fora do horário',
    OutOfEntryTolerance: 'Fora da entrada tolerada',
    BlockWithoutReservation: 'Sem Reserva para este horário',
    PersonNotFound: 'Não encontrado',
    PersonInactive: 'Inativo. Contate a recepção',
    OutstandingPayment: 'Pagamento em aberto',
    SubscriptionClosed: 'Assinatura encerrada em [dataencerramento]',
    SubscriptionLocked: 'Assinatura trancada até [fimtrancamento]',
    SubscriptionRecess: 'Assinatura em recesso até [fimrecesso]',
    ReentryDenied: 'Reentrada não permitida',
    MorningExit: 'Tenha um bom-dia!',
    AfternoonExit: 'Tenha uma boa-tarde!',
    NightExit: 'Tenha uma boa-noite!',
    WithoutSubscription: 'Sem assinatura. Contate a recepção',
  },
  'en-US': {
    Birthday: 'Happy birthday!',
    EvaluationExpired: 'Physical evaluation expired',
    PassesExhausted: 'Passes exhausted',
    EntryCustomer: 'Have a good workout!',
    EntryCustomerPass: 'Have a good workout! [restam] passes remaining',
    EntryEmployee: 'Have a good day at work!',
    MedicalExamExpired: 'Medical exam expired',
    OutOfHours: 'Outside operating hours',
    OutOfEntryTolerance: 'Outside entry tolerance',
    BlockWithoutReservation: 'No reservation for this time',
    PersonNotFound: 'Not found',
    PersonInactive: 'Inactive. Contact reception',
    OutstandingPayment: 'Outstanding payment',
    SubscriptionClosed: 'Subscription closed on [dataencerramento]',
    SubscriptionLocked: 'Subscription locked until [fimtrancamento]',
    SubscriptionRecess: 'Subscription on recess until [fimrecesso]',
    ReentryDenied: 'Reentry not allowed',
    MorningExit: 'Have a good morning!',
    AfternoonExit: 'Have a good afternoon!',
    NightExit: 'Have a good night!',
    WithoutSubscription: 'No subscription. Contact reception',
  },
  'es-ES': {
    Birthday: '¡Feliz cumpleaños!',
    EvaluationExpired: 'Evaluación física vencida',
    PassesExhausted: 'Pases agotados',
    EntryCustomer: '¡Buen entrenamiento!',
    EntryCustomerPass: '¡Buen entrenamiento! Quedan [restam] pases',
    EntryEmployee: '¡Buen trabajo!',
    MedicalExamExpired: 'Examen médico vencido',
    OutOfHours: 'Fuera del horario',
    OutOfEntryTolerance: 'Fuera de la tolerancia de entrada',
    BlockWithoutReservation: 'Sin reserva para este horario',
    PersonNotFound: 'No encontrado',
    PersonInactive: 'Inactivo. Contacte la recepción',
    OutstandingPayment: 'Pago pendiente',
    SubscriptionClosed: 'Suscripción cerrada el [dataencerramento]',
    SubscriptionLocked: 'Suscripción bloqueada hasta [fimtrancamento]',
    SubscriptionRecess: 'Suscripción en receso hasta [fimrecesso]',
    ReentryDenied: 'Reingreso no permitido',
    MorningExit: '¡Que tengas un buen día!',
    AfternoonExit: '¡Que tengas una buena tarde!',
    NightExit: '¡Que tengas una buena noche!',
    WithoutSubscription: 'Sin suscripción. Contacte la recepción',
  },
};

const LANGUAGE_MAP: Record<string, string> = {
  'pt': 'pt-BR',
  'pt-BR': 'pt-BR',
  'en': 'en-US',
  'en-US': 'en-US',
  'es': 'es-ES',
  'es-ES': 'es-ES',
};

export const getDefaultMessages = (language: string = 'pt-BR'): IStandardMessage => {
  const lang = language || 'pt-BR';
  const mappedLang = LANGUAGE_MAP[lang] || 'pt-BR';
  return DEFAULT_MESSAGES[mappedLang] || DEFAULT_MESSAGES['pt-BR'];
};
